import React from 'react';
import { useFormContext } from 'react-hook-form';
import SvgIconButton from '../buttons/Svg-Icon-button';
import PlusIcon from '../../assets/svgs/PlusIcon';
import MinusIcon from '../../assets/svgs/MinusIcon';
import './Form.css';

interface CounterFieldProps {
  name: string;
  label: string;
  required?: boolean;
  min?: number;
  max?: number;
  requiredMessage?: string;
  validation?: {
    required?: string | boolean;
    min?: number | { value: number; message: string };
    max?: number | { value: number; message: string };
    [key: string]: any;
  };
  className?: string;
}

const CounterField: React.FC<CounterFieldProps> = ({ 
  name, 
  label, 
  required = false, 
  min = 0, 
  max = 100,
  requiredMessage = 'This field is required',
  validation = {},
  className = '',
}) => {
  const { register, setValue, watch, formState: { errors } } = useFormContext();
  const currentValue = watch(name) || min;

  const increment = () => {
    if (currentValue < max) {
      setValue(name, currentValue + 1, { shouldValidate: true });
    }
  };

  const decrement = () => {
    if (currentValue > min) {
      setValue(name, currentValue - 1, { shouldValidate: true });
    }
  };

  return (
    <div className={`form-group ${className}`}>
      <label className="fw-600">
        {label} {required && <span className="text-danger">*</span>}
      </label>
      <div className="d-flex gap-2 align-items-center">
        <SvgIconButton 
          Icon={<MinusIcon width="20" height="10" />} 
          onClick={decrement} 
        />
        <input
          type="text"
          className={`form-control text-center counter-input ${errors[name] ? 'is-invalid' : ''}`}
          value={currentValue}
          {...register(name, {
            required: required ? requiredMessage : false,
            min: {
              value: min,
              message: `Minimum value is ${min}`
            },
            max: {
              value: max,
              message: `Maximum value is ${max}`
            },
            ...validation
          })}
          readOnly
        />
        <SvgIconButton 
          Icon={<PlusIcon width="20" height="10" />} 
          onClick={increment} 
        />
      </div>
      {errors[name] && (
        <div className="invalid-feedback d-block">
          {errors[name]?.message as string}
        </div>
      )}
    </div>
  );
};

export default CounterField;